export default "/images/chrome.svg?9afafdbadd3f58382f91e18b9159feb2";